import { defaultStore, stores } from '../../../../../translations';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import React from 'react';
import content from '../../constants/content';
import { useModal } from '../../../../../hooks/useModal';
import { useProducts } from '../../../../../redux/reducer/content';

const { VICHIAndLaRochePosayModal } = content;

export default function LaRocheCorner() {
  const { buyProducts } = useProducts();
  const { addModal } = useModal();

  const onClick = () => {
    addModal({
      type: 'quizWinModal',
      props: {
        ...VICHIAndLaRochePosayModal,
        selectionProducts: buyProducts?.filter?.(({ is_shop_selection }) => is_shop_selection),
      },
    });
  };

  return (
    defaultStore === stores.ru && (
      <div className={'interactive-shop__item interactive-shop__item_la-roche-corner'}>
        <CustomButton className={'interactive-shop__item_la-roche-corner_button'} onClick={onClick} />
      </div>
    )
  );
}
